module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-0e5bbbfb.png";